import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { space, SpaceProps } from 'styled-system';
import Box from 'ui/Box';
import Body from 'ui/Typography/Body';
import { animated, useSpring } from 'react-spring';

const MenuWrapper = styled(Box)`
  position: relative;
  flex-grow: 1;
  height: 100%;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  margin-bottom: ${({ theme }) => theme.space.xl};
`;

const SelectedMenuWrapper = styled(MenuWrapper)`
  height: auto;
  background-color: ${({ theme }) => theme.colors.white};
`;

const ChildrenWrapper = styled.div`
  overflow-y: auto;
  height: 100%;
`;

export const Menu = React.forwardRef<HTMLDivElement, PropsWithChildren<{ onScroll?: () => void }>>(
  (props, ref) => {
    return (
      <MenuWrapper {...props} onScroll={props.onScroll}>
        <ChildrenWrapper ref={ref}>{props.children}</ChildrenWrapper>
      </MenuWrapper>
    );
  }
);
// Same as componant above, but with no forward ref and styling
export const SelectedMenuContainer: React.FunctionComponent<{
  children: React.ReactNode;
}> = props => {
  return <SelectedMenuWrapper>{props.children}</SelectedMenuWrapper>;
};

export const FullWidthMenu = styled(MenuWrapper)`
  position: absolute;
  top: 0;
  left: 0;
  background: white;
`;

export const MenuTitle = styled.div<SpaceProps>`
  ${space}
  display: flex;
  justify-content: flex-start;
  position: sticky;
  top: 0;
  min-height: ${({ theme }) => theme.space.xxxl};
  background: white;
  z-index: 1;
  align-items: center;
  padding-left: ${({ theme }) => theme.space.xl};
  padding-right: ${({ theme }) => theme.space.xl};
`;

export const ListHeading = styled(Body)`
  font-weight: bold;
  padding: ${({ theme }) => theme.space.md} 0;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 100%;
`;

export const FadeUp = (props: any) => {
  const animationProps = useSpring({
    from: { opacity: 0, y: 50 },
    to: { opacity: 1, y: 0 }
  });

  return (
    <animated.div
      style={{
        background: 'white',
        opacity: animationProps.opacity,
        transform: animationProps.y.to((y: number) => `translateY(${y}px)`)
      }}
      {...props}
    />
  );
};

export const List = styled.ul`
  margin: 10px 0;
  list-style-type: none;
  display: flex;
  flex-wrap: wrap;
  padding: 0;
  width: 100%;
`;

export const ListItem = styled.li`
  max-width: 50%;
  width: 100%;
  padding: calc(0.5rem - 4px);
  border: 2px solid transparent;
  border-radius: 2px;

  &[aria-selected='true'] {
    border-color: ${props => props.theme.colors.feedback.focus};
  }
  &:focus {
    outline: 0.125rem solid ${({ theme }) => theme.colors.feedback.focus};
  }
`;

export const AltListItem = styled.ul`
  max-width: initial;
  width: 100%;
  border: 2px solid transparent;
  border-radius: 2px;
  margin: 0;
  padding: 0;

  &[aria-selected='true'] {
    border-color: ${props => props.theme.colors.feedback.focus};
  }
  &:focus {
    outline: 0.125rem solid ${({ theme }) => theme.colors.feedback.focus};
  }
`;
